import { useController } from 'react-hook-form';
import { CHECKBOX_STATUS, Checkbox, CheckboxProps } from 'ui/checkbox';
import { FieldProps } from './types';

type CheckboxFieldProps = FieldProps & Omit<CheckboxProps, 'status' | 'onClick'>;

export const CheckboxField = ({ name, ...rest }: CheckboxFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue: false,
  });

  return (
    <Checkbox
      {...rest}
      name={name}
      status={value ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
      onClick={() => onChange(!value)}
    />
  );
};
